module.exports = __webpack_public_path__ + "static/media/cd2-icon-upcoming.27600905.svg";